import { render, staticRenderFns } from "./detail-message.vue?vue&type=template&id=080dca08&scoped=true"
import script from "./detail-message.vue?vue&type=script&lang=ts"
export * from "./detail-message.vue?vue&type=script&lang=ts"
import style0 from "./detail-message.vue?vue&type=style&index=0&id=080dca08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080dca08",
  null
  
)

export default component.exports